import Grid from '@material-ui/core/Grid';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';
import ItemCard from '../ItemCard/ItemCard';
import { OrderingItem } from 'kiolyn-api';
import { isNullOrUndefined } from 'util';

interface ItemGridProps {
  items?: OrderingItem[];
  getUnavailableMessage?: (item: OrderingItem) => string;
  onSelect?: (item: OrderingItem) => void;
  acceptOrdering?: boolean;
}

const ItemGrid: FC<ItemGridProps> = ({
  items,
  getUnavailableMessage,
  onSelect,
  acceptOrdering
}: ItemGridProps) => {
  if (isNullOrUndefined(items) || isEmpty(items)) {
    return null;
  }

  const internalGetUnavailableMessage = (item: OrderingItem) => {
    if (!isNullOrUndefined(getUnavailableMessage)) {
      return getUnavailableMessage(item);
    }
  };

  return (
    <Grid container spacing={2} justify="center">
      {items.map(item => (
        <Grid item key={item.id} xs={12} sm={6} md={4}>
          <ItemCard
            item={item}
            unavailableMessage={internalGetUnavailableMessage(item)}
            onSelect={onSelect}
            acceptOrdering={acceptOrdering}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ItemGrid;
